// eslint-disable-next-line import/no-cycle
import modules from './modules';

export function loadAsyncModules(element) {
  const asyncModules = element.querySelectorAll('[data-async-module]');
  asyncModules.forEach(async (module) => {
    const selectedModule = modules.find(
      (m) => m.name === module.dataset.asyncModule
    );
    const { default: LoadedModule } = await selectedModule.loader();
    new LoadedModule(module);
    module.removeAttribute('data-async-module');
  });
}
